import mrpStyles from './../mrp.json'

export default {
  color: mrpStyles.colors.PrimaryBlack,
  borderColor: mrpStyles.colors.SecondaryGreySteel,
  hover: {
    borderColor: mrpStyles.colors.SecondaryGreySky
  },
  active: {
    borderColor: mrpStyles.colors.PrimaryBlack
  }
}
